/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Components
import { cloneDeep } from 'lodash';
import HtmlEditor from 'shared/ui/components/editors/html/HtmlEditor.vue';
import GenericDocExternalPicker from 'shared/ui/components/form-components/pickers/GenericDocExternalPicker.vue';

const __vue_script__ = {
    name: 'SessionRegistrationModal',

    components: { HtmlEditor, GenericDocExternalPicker },

    props: {
        eventId: {
            type: String,
            default: null
        },

        lang: {
            type: String,
            required: true
        },

        saveCallback: {
            type: Function,
            required: true
        },

        name: {
            type: String,
            default: null
        },

        value: {
            type: Object,
            default: () => ({})
        },

        editing: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            innerValue: {}
        };
    },

    watch: {
        value: {
            immediate: true,
            deep: true,
            handler(value) {
                this.content = cloneDeep(value.content);
                this.fp_ext_ids = cloneDeep(value.fp_ext_ids);
            }
        }
    },

    methods: {
        submit() {
            this.saveCallback({
                type: 'sessions',
                name: this.name,
                fp_ext_ids: this.fp_ext_ids,
                content: this.content,
                removable: true
            });
            this.$emit('close');
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('form',{staticClass:"session-registration-modal modal-wrapper",on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.submit)}}},[_c('div',{staticClass:"modal-header"},[_c('h2',[_vm._v(_vm._s(_vm.$t(("registration.configuration.form." + (_vm.editing ? 'edit' : 'add') + "_session_registration"))))])]),_c('div',{staticClass:"modal-body"},[_c('validation-provider',{attrs:{"slim":true,"name":"session_registration"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('html-editor',{ref:"html",attrs:{"event-id":_vm.eventId,"name":"session_registration","links":true,"enable-custom-bstg-links":false,"extras":false,"images":true,"errors":errors,"blockquote":true},model:{value:(_vm.content[_vm.lang]),callback:function ($$v) {_vm.$set(_vm.content, _vm.lang, $$v)},expression:"content[lang]"}})]}}],null,true)}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"ext"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('generic-doc-external-picker',{attrs:{"errors":errors,"event-id":_vm.eventId,"label":_vm.$t('registration.configuration.form.section_types.session'),"placeholder":_vm.$t('registration.configuration.form.placeholders.session'),"multiple":true,"show-deleted-docs":true,"sortable":false,"appscript":"agenda/find-non-master-sessions","fp-type":"session","name":"ext"},model:{value:(_vm.fp_ext_ids),callback:function ($$v) {_vm.fp_ext_ids=$$v},expression:"fp_ext_ids"}})]}}],null,true)})],1),_c('div',{staticClass:"modal-footer"},[_c('footer',{staticClass:"actions"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_c('button',{staticClass:"btn btn-primary"},[_vm._v(_vm._s(_vm.$t( _vm.editing ? 'general.save' : 'general.add')))])])])])]}}])})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "SessionRegistrationModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__